
import { gsap } from "gsap"
import { colors, validateEmail, language } from "./bundle"
let $ = jQuery
let homeUrl = document.getElementById('homeUrl').value
class Form {
    constructor(form) {
        this.form = form
        this.formName = this.form.getAttribute('data-formname')
        this.isWaiting = false
        this.isAnimating = false

        if (this.form.querySelector('.submit') !== null) {
            this.submit = this.form.querySelector('.submit')
            this.submitTxt = this.submit.querySelector('.txt')
            this.ctaTxt = this.submitTxt.innerHTML

        }

        if (this.form.querySelector('.errore-generico') !== null) {
            this.erroreGenerico = this.form.querySelector('.errore-generico')
            this.erroreGenericoTxt = this.erroreGenerico.querySelector('.txt')
            this.erroreGenericoDefaultTxt = this.erroreGenericoTxt.innerHTML
        }

        this.checkboxesObbligatorie = this.form.querySelectorAll('.checkbox.campo-obbligatorio')
        this.arrayCheckoxesObbligatorie = [...this.checkboxesObbligatorie].map(cb => new Checkbox(cb))

        if (this.form.querySelectorAll('.input') !== null) {
            this.arrayInputs = [...this.form.querySelectorAll('.input')].map(input => new InputText(input));
        }

        if (this.form.querySelectorAll('.select') !== null) {
            this.arraySelects = [...this.form.querySelectorAll('.select')].map(select => new InputSelect(select));
        }

        //Dati per iscrizione newsletter
        this.APIKey = "b58e-c9f1-bbd5-d47e-15bd-35bb-2e0c-3f9c"
        // this.listaItalia = 88547
        // this.listaEstero = xxxxx
        // this.lista = language === 'it' ? this.listaItalia : this.listaEstero
        this.lista = 88547

        // this.setRowZindex();
        this.initEvents();

    }

    initEvents() {
        this.form.addEventListener('submit', e => {
            e.preventDefault()
        })
        if (this.form.querySelector('.submit') !== null) {
            this.submit.addEventListener('click', () => {
                if (this.isWaiting) return;
                this.startWaiting()
                this.checkErrors()
            })
        }
    }

    // resetTxtErroreGenerico(){
    //     this.erroreGenericoTxt.innerHTML = this.erroreGenericoDefaultTxt
    // }

    startWaiting() {
        let txt = 'ATTENDERE...'
        if (language !== 'it') {
            txt = 'PLEASE WAIT...'
        }
        this.isWaiting = true
        this.submit.classList.add('is-waiting')
        this.submitTxt.innerHTML = txt
        gsap.to(this.submit, {
            duration: 0,
            cursor: 'default'
        })
        gsap.to(this.submit, {
            duration: 0.4,
            autoAlpha: 0.3
        })
    }

    stopWaiting() {
        this.isWaiting = false
        this.submit.classList.remove('is-waiting');
        this.submitTxt.innerHTML = this.ctaTxt;
        gsap.to(this.submit, {
            duration: 0,
            cursor: 'pointer'
        })
        gsap.to(this.submit, {
            duration: 0.4,
            autoAlpha: 1
        })
    }
    //le select devono coprire gli altri field quando le apro
    // setRowZindex(){
    // 	let arrayFormRows = [...this.form.querySelectorAll('.form__row')];
    // 	let quanteRow = arrayFormRows.length;
    // 	arrayFormRows.forEach( (row, index) => {
    // 		TweenMax.set(row,{
    // 			'z-index': quanteRow - index
    // 		})
    // 	})
    // }

    checkErrors() {
        this.arrayErrors = []

        this.arrayCheckoxesObbligatorie.forEach(checkboxClass => {
            let errorValue = checkboxClass.checkStatus()
            if (errorValue === 'si') {
                this.arrayErrors.push(errorValue)
            }
        })


        this.arrayInputs.forEach(inputCLass => {
            if (inputCLass.input.classList.contains('campo-obbligatorio')) {
                let errorValue = inputCLass.checkStatus()
                if (errorValue === 'si') {
                    this.arrayErrors.push(errorValue)
                }
            }
        })
        this.arraySelects.forEach( selectCLass => {
        	if(selectCLass.select.classList.contains('campo-obbligatorio')){
        		let errorValue = selectCLass.checkStatus()
        		if(errorValue === 'si'){
        			this.arrayErrors.push(errorValue)
        		}
        	}
        })

        //se ci sono errori
        if (this.arrayErrors.length > 0) {
            // console.log('ci sono errori')
            if (this.formName !== 'registrazione') {
                if (this.form.querySelector('.errore-generico') !== null) {
                    gsap.to(this.erroreGenericoTxt, {
                        duration: 0.4,
                        autoAlpha: 1
                    })
                }

            }
            // this.scrollToError()
            this.stopWaiting()
            // this.submitForm(this.formName)	//!commentare o cancellare quando si va online

        }
        //se NON ci sono errori
        else {
            // console.log('non ci sono errori')
            if (this.form.querySelector('.errore-generico') !== null) {
                gsap.to(this.erroreGenericoTxt, {
                    duration: 0.4,
                    autoAlpha: 0
                })
            }
            this.submitForm(this.formName)
        }
    }

    thankyouMessage(formName) {
        let thankyou = document.querySelector('.thankyou-' + formName)
        let thankyouBg = thankyou.querySelector('.thankyou__bg span')
        // let thankyouWraper = thankyou.querySelector('.thankyou__wrapper')
        let thankyouTxt = thankyou.querySelectorAll('.thankyou__wrapper p')
        let delay = 8
        // if(this.formName == 'login'){
        // 	delay = 2
        // }
        // if(this.formName == 'registrazione'){
        // 	delay = 2
        // }
        if (this.formName == 'newsletter') {
            delay = 4
        }
        return new Promise((resolve, reject) => {

            gsap.to(thankyou, {
                duration: 0,
                autoAlpha: 1
            })

            gsap.to(thankyouBg, {
                duration: 0.5,
                autoAlpha: 1
            })
            gsap.to(thankyouTxt, {
                duration: 0.5,
                delay: 0.4,
                autoAlpha: 1
            })
            gsap.to(thankyouTxt, {
                duration: 1,
                delay: delay,
                autoAlpha: 0,
                onComplete: () => {
                    resolve();
                }
            })
        })
    }
    submitForm(formName) {
        // console.log(formName)
        if (formName === 'login') {
            this.inviaFormLogin()
        }
        else if (formName === 'contatti') {
            this.inviaFormContatti()
        }
        else if (formName === 'newsletter') {
            this.inviaFormNewsletter()
        }
        else if (formName === 'registrazione') {
            this.inviaFormRegistrazione()
        }
        // else if (formName === 'reso') {
        // 	this.inviaFormReso()
        // }
        // else if (formName === 'assistenza') {
        // 	this.inviaFormAssistenza()
        // }
    }
    inviaFormLogin() {
        let formData = new FormData(this.form)
        let request = new XMLHttpRequest()
        // let redirectLink = homeUrl
        formData.append('action', 'login_user')
        // formData.append('lang', getCookie('wp-wpml_current_language'))
        // formData.append('user', user)
        // formData.append('pass', pass)
        // formData.append('remember', remember)
        let url = document.getElementById('uri').value + '/AJAX/user.php'
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                // console.log(request)
                let res = JSON.parse(request.response)
                // console.log(res)
                if (res.return == '200') {
                    return new Promise(resolve => {
                        gsap.to(this.erroreGenericoTxt, {
                            duration: 0.4,
                            autoAlpha: 0,
                            onComplete: () => {
                                this.erroreGenericoTxt.style.color = colors.success
                                if (language === 'it') {
                                    this.erroreGenericoTxt.innerHTML = 'login effettuato con successo'
                                }
                                else {
                                    this.erroreGenericoTxt.innerHTML = 'login successful'
                                }
                                resolve()
                            }
                        })



                    }).then(() => {
                        return new Promise(resolve => {
                            gsap.to(this.erroreGenericoTxt, {
                                duration: 0.4,
                                autoAlpha: 1,
                                onComplete: () => {
                                    setTimeout(() => {
                                        resolve()
                                    }, 1000)
                                }
                            })
                        })
                    }).then(() => {
                        location.reload()
                    })
                }
                else {
                    this.stopWaiting()
                    if (this.form.querySelector('.errore-generico') !== null) {
                        gsap.to(this.erroreGenericoTxt, {
                            duration: 0.4,
                            autoAlpha: 1
                        })
                    }
                }
            }
        }
        request.send(formData)


    }
    inviaFormContatti() {
        // console.log('invia form')
        let formData = new FormData(this.form)
        let request = new XMLHttpRequest()
        let url = document.getElementById('uri').value + '/AJAX/contacts.php'
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                // let res = JSON.parse(request.response)
                // console.log(res)

                // if (res.return == '200') {
                this.thankyouMessage('contatti').then(() => {
                    window.location.reload()
                })

                // }

            }
        }
        request.send(formData)

    }

    inviaFormNewsletter() {
        // let formData = new FormData(this.form);
        // let request = new XMLHttpRequest();
        // formData.append('action', 'submit_newsletter')
        // let url = document.getElementById('uri').value + '/AJAX/user.php'
        // request.open('POST', url, true);
        // request.onreadystatechange = () => {
        //     if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
        //         let res = JSON.parse(request.response);
        //         // console.log(res.email)
        //         if (res.response == 200) {
        //             let body = {
        //                 "email_address": res.email.trim(),
        //                 "subscription": {
        //                     "ip": document.getElementById('newsletter-ip').value.toUpperCase(),
        //                     "status": "Subscribed"
        //                 },
        //                 "triggers": {
        //                     "automation": true,
        //                     "behaviors": false,
        //                     "send_confirmation_email": true
        //                 },
        //                 "update_if_duplicate": false,
        
        //             }
        //             // console.log(body)
        //             this.fetch4DEMApi(body)
        //         }
        //     }
        // };
        // request.send(formData);
		let APIKey = this.APIKey
		let lista = this.lista
        let emailAddress = this.form.querySelector('input[name="EMAIL"]').value
		this.fetch4DEMApi(APIKey, lista, emailAddress)

    }
	fetch4DEMApi(APIKey, lista, emailAddress){
        console.log('fetch me')
        let formData = new FormData(this.form)
        let request = new XMLHttpRequest()
        formData.append('action', 'subscribe')
        formData.append('APIKey', APIKey)
        formData.append('lista', lista)
        formData.append('emailAddress', emailAddress)
        let url = document.getElementById('uri').value + '/AJAX/iscrizione-newsletter.php'
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                // let res = JSON.parse(request.response)
                // console.log(res.token)
                console.log(request.response)

                this.thankyouMessage('newsletter').then(() => {
                    window.location.reload();
                })

            }
        }
        request.send(formData)

	}
    // fetch4DEMApi(body){
    //     fetch("https://api.4dem.it/api/authenticate", {
    //         method: "POST",
    //         headers: {
    //             "Content-Type": "application/json",
    //         },
    //         body: JSON.stringify({
    //             APIKey: this.APIKey
    //         })
    //     })
    //     .then( res => res.json())
    //     .then( data => {
    //         fetch(`https://api.4dem.it/api/recipients/${this.lista}/subscribe?token=${data.token}`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify(body)
    //         })
    //         .then( res => res.json())
    //         .then( data => {
    //             //Iscritto con successo
    //             this.thankyouMessage('newsletter').then(() => {
    //                 window.location.reload();
    //             })
    //         })
    //         .catch( error => {
    //             //Errore nell'iscrizione
    //             console.log(error)
    //             // this.footerNewsletter.classList.remove('waiting')
    //         })
    //     })
    //     .catch( error => {
    //         console.log(error)
    //     })
    // }

    inviaFormRegistrazione() {
        let formData = new FormData(this.form)
        let request = new XMLHttpRequest()
        // let redirectLink = document.querySelector('.page-registrazione').getAttribute('data-redirect')
        formData.append('action', 'register_user')
        let url = document.getElementById('uri').value + '/AJAX/user.php'
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                // console.log(request)
                let res = JSON.parse(request.response)
                if (res.return == '200') {
                    return new Promise(resolve => {
                        gsap.to(this.erroreGenericoTxt, {
                            duration: 0.4,
                            autoAlpha: 0,
                            onComplete: () => {
                                this.erroreGenericoTxt.style.color = colors.success
                                if (language === 'it') {
                                    this.erroreGenericoTxt.innerHTML = 'registrazione avvenuta con successo'
                                }
                                else {
                                    this.erroreGenericoTxt.innerHTML = 'registration successful'
                                }
                                resolve()
                            }
                        })
                    }).then(() => {
                        return new Promise(resolve => {
                            gsap.to(this.erroreGenericoTxt, {
                                duration: 0.4,
                                autoAlpha: 1,
                                onComplete: () => {
                                    setTimeout(() => {
                                        resolve()
                                    }, 1000)
                                }
                            })
                        })
                    }).then(() => {
                        // location.reload()
                        window.location.href = homeUrl
                        //Siccome non faccio nè redirect nè reload, resetto tutti i campi e apro in automatico il popup con la form per il login che si trova nell'header
                        // document.querySelector('.header-login').click()
                        // if (this.form.querySelectorAll('.input') !== null) {
                        //     // this.arrayInputs = [...this.form.querySelectorAll('.input')].map(input => new InputText(input))
                        //     this.arrayInputs.forEach(inputClass => {
                        //         inputClass.resetField()
                        //     })
                        // }
                        // this.arrayCheckoxesObbligatorie.forEach(cb => {
                        //     cb.changeCheckboxStatus()
                        // })
                        // gsap.to(this.erroreGenericoTxt, {
                        // 	duration: 0.4,
                        // 	autoAlpha: 0,
                        //     onComplete: () => {
                        //         this.erroreGenericoTxt.innerHTML = this.erroreGenericoDefaultTxt
                        //     }
                        // })
                        // this.stopWaiting()
                    })
                }
                else {
                    this.stopWaiting()
                    if (this.form.querySelector('.errore-generico') !== null) {
                        gsap.to(this.erroreGenericoTxt, {
                            duration: 0.4,
                            autoAlpha: 1
                        })
                    }

                }
            }
        }
        request.send(formData)

    }

}

class InputText {
    constructor(input) {
        this.input = input
        this.label = this.input.closest('.form__row').querySelector('.label');
        if (!this.input.classList.contains('input--textarea')) {
            this.inputField = this.input.querySelector('input')
        }
        else {
            this.inputField = this.input.querySelector('textarea')
        }
        if (this.input.classList.contains('input--password')) {
            this.viewPasswordBtn = this.input.querySelector('.view-password-btn')
        }
        if (this.input.closest('.error-check-container') !== null) {
            this.errorCheckContainer = this.input.closest('.error-check-container')
            this.labelError = this.errorCheckContainer.querySelector('.label__error')
            this.labelErrorSpan = this.labelError.querySelector('span')
            this.defaultLabelErrorTxt = this.labelErrorSpan.innerHTML
        }
        this.isInputEmail = false


        this.originalColorBorder = getComputedStyle(this.input).borderColor

        if (this.input.classList.contains('input--email')) {
            this.isInputEmail = true
        }
        if (this.input.classList.contains('input--email--newsletter-footer')) {
            this.isInputEmailNewsletterFooter = true
        }
        this.duration = 0.4


        this.initEvents();
    }

    initEvents() {
        let topFocus = '15%'
        // let topStart = '50%'
        if (this.isInputEmailNewsletterFooter) {
            topFocus = '-15%'
        }
        if (this.inputField.value !== '') {
            gsap.to(this.input, {
                duration: this.duration,
                'border-bottom-width': 1,
                borderColor: colors.success
            });
            gsap.to(this.label, {
                duration: this.duration,
                top: topFocus,
                scale: 0.5
            })

        }

        this.inputField.addEventListener('focus', e => {
            gsap.to(this.input, {
                duration: this.duration,
                'border-bottom-width': 3,
            })

            gsap.to(this.label, {
                duration: this.duration,
                top: topFocus,
                scale: 0.5
            })
            // if(this.input.classList.contains('exclude-quick-check')){
            if (this.input.classList.contains('campo-obbligatorio')) {
                this.hideError()
            }
            this.borderStandby()
            // }
        })

        this.inputField.addEventListener('blur', e => {
            gsap.to(this.input, {
                duration: this.duration,
                'border-bottom-width': 1,
            })
            if (this.inputField.value == '') {
                gsap.to(this.label, {
                    duration: this.duration,
                    top: '50%',
                    scale: 1
                })
            }
            //Esempio: per il coupon non serve che controllo al blur o keyup
            // if(!this.input.classList.contains('exclude-quick-check')){
            if (this.input.classList.contains('campo-obbligatorio')) {
                this.hideError()
            }
            this.borderStandby()
            // }
        })

        this.inputField.addEventListener('keyup', () => {
            if (this.input.closest('.error-check-container') !== null && this.errorCheckContainer.classList.contains('errore-attivo')) {
                //Esempio: per il coupon non serve che controllo al blur/keyup
                if (!this.input.classList.contains('exclude-check-focus')) {
                    // this.checkStatus()
                }
            }
            if (this.inputField.getAttribute('type') === 'email' && (document.querySelector('.page-contatti') !== null || document.querySelector('.page-apri-con-noi') !== null)) {
                let thankyou = document.querySelector('.thankyou-contatti')
                thankyou.querySelector('.js-email').innerHTML = this.inputField.value
            }
            // if (this.inputField.classList.contains('email-reso')) {
            // 	let thankyou = document.querySelector('.thankyou-reso')
            // 	thankyou.querySelector('.js-email').innerHTML = this.inputField.value
            // }
        })

        //Alcuni campi potrebbero essere precompilati, quindi chekko anche all'init
        if (this.inputField.getAttribute('type') === 'email' && (document.querySelector('.page-contatti') !== null || document.querySelector('.page-apri-con-noi') !== null)) {
            let thankyou = document.querySelector('.thankyou-contatti')
            thankyou.querySelector('.js-email').innerHTML = this.inputField.value
        }
        // if(this.inputField.classList.contains('email-reso')){
        // 	let thankyou = document.querySelector('.thankyou-reso')
        // 	thankyou.querySelector('.js-email').innerHTML = this.inputField.value
        // }
        // if(this.inputField.classList.contains('email-assistenza')){
        // 	let thankyou = document.querySelector('.thankyou-contatti')
        // 	thankyou.querySelector('.js-email').innerHTML = this.inputField.value
        // }


        if (this.input.classList.contains('input--password')) {
            this.viewPasswordBtn.addEventListener('click', () => {
                this.toggleViewPassword()
            })
        }
    }
    toggleViewPassword() {
        // console.log('click')
        if (this.inputField.type === "password") {
            this.inputField.type = "text"
        } else {
            this.inputField.type = "password"
        }
    }
    resetField() {
        this.inputField.value = ''
    }

    checkStatus() {
        if (this.input.classList.contains('campo-obbligatorio')) {
            let inputValue = this.inputField.value
            let errorValue = ''
            //campo txt
            if (!this.isInputEmail) {
                if (inputValue == '') {

                    if (this.input.closest('.error-check-container') !== null) {
                        this.resetTextError()
                    }
                    this.showError()
                    // this.borderActiveWrong()
                    errorValue = 'si'
                }
                else {
                    this.hideError()
                    // this.borderActiveCorrect()
                    errorValue = 'no'
                }
            }
            //campo email
            else {
                if (inputValue == '') {
                    // this.resetTextError()
                }
                if (!validateEmail(inputValue)) {
                    this.showError()
                    // this.borderActiveWrong()
                    errorValue = 'si'
                }
                else {
                    this.hideError()
                    // this.borderActiveCorrect()
                    errorValue = 'no'
                }

            }
            return errorValue
        }
    }

    // setTextError(txt){
    //     this.labelErrorSpan.innerHTML = txt
    // }
    resetTextError() {
        this.labelErrorSpan.innerHTML = this.defaultLabelErrorTxt
    }

    showError() {
        gsap.to(this.labelError, {
            duration: this.duration,
            autoAlpha: 1
        });
        this.errorCheckContainer.classList.add('errore-attivo');
    }
    hideError() {
        gsap.to(this.labelError, {
            duration: this.duration,
            autoAlpha: 0
        });
        this.errorCheckContainer.classList.remove('errore-attivo');
    }
    borderActiveCorrect() {
        gsap.to(this.input, {
            duration: this.duration,
            borderColor: colors.success
        });
    }
    borderActiveWrong() {
        gsap.to(this.input, {
            duration: this.duration,
            borderColor: colors.error
        });
    }
    borderStandby() {
        gsap.to(this.input, {
            duration: this.duration,
            borderColor: this.originalColorBorder
        });

    }
}

class Checkbox {
    constructor(cb) {
        this.cb = cb
        this.unchecked = this.cb.querySelector('.unchecked')
        this.svgUnchecked = this.cb.querySelector('.svg-unchecked')
        this.checked = this.cb.querySelector('.checked')
        this.svgChecked = this.cb.querySelector('.svg-checked')
        this.txt = this.cb.querySelector('.checkbox__txt')
        this.txtSpan = this.txt.querySelector('span')
        if (this.txt.querySelector('a') !== null) {
            this.txtAnchor = this.txt.querySelector('a')
            this.originalColorLink = getComputedStyle(this.txtAnchor).color
        }

        this.originalColorTxt = getComputedStyle(this.txtSpan).color

        this.initEvents()
    }
    initEvents() {
        this.cb.addEventListener('click', () => {
            this.changeCheckboxStatus()
        })
    }

    changeCheckboxStatus() {
        this.dataCheckboxStatus = this.cb.getAttribute('data-checkboxstatus')
        if (this.dataCheckboxStatus == 'checked') {
            gsap.to(this.checked, 0.6, {
                autoAlpha: 0
            })
            this.cb.dataset.checkboxstatus = 'unchecked'
        }
        else {
            gsap.to(this.checked, 0.6, {
                autoAlpha: 1
            })
            gsap.to(this.svgUnchecked, 0.6, {
                // stroke:colorBlack
                stroke: this.originalColorTxt
            })
            gsap.to(this.txtSpan, 0.6, {
                color: this.originalColorTxt
            })
            if (this.txt.querySelector('a') !== null) {
                gsap.to(this.txtAnchor, {
                    duration: 0.6,
                    // color:colorBlack
                    color: this.originalColorLink
                })
            }
            this.cb.dataset.checkboxstatus = 'checked'
        }
    }

    checkStatus() {
        if (this.cb.classList.contains('campo-obbligatorio')) {
            this.dataCheckboxStatus = this.cb.getAttribute('data-checkboxstatus')
            let errorValue = ''
            if (this.dataCheckboxStatus == 'unchecked') {
                gsap.to(this.svgUnchecked, 0.6, {
                    stroke: colors.error
                })
                gsap.to(this.txtSpan, 0.6, {
                    color: colors.error
                })
                if (this.txt.querySelector('a') !== null) {
                    gsap.to(this.txtAnchor, 0.6, {
                        color: colors.error
                    })
                }
                errorValue = 'si'
            }
            else {
                errorValue = 'no'
            }
            return errorValue
        }
    }
}

class InputSelect{
	constructor(select){
		this.select = select
        console.log(this.select)
		this.selectHeader = this.select.querySelector('.select__header')
		this.selectHeaderTxt = this.selectHeader.querySelector('.select__header__text')
		this.selectBody = this.select.querySelector('.select__fake')
		this.selectBodyList = this.selectBody.querySelector('.fake__list')
		this.selectBodyListHeight = this.selectBodyList.getBoundingClientRect().height
		this.fakeSelect = this.select.querySelector('select.select__real')

		if(this.select.closest('.error-check-container') !== null){
			this.errorCheckContainer = this.select.closest('.error-check-container')
			this.labelError = this.errorCheckContainer.querySelector('.label__error')
		}

		this.options = [...this.select.querySelectorAll('.fake__option')]

		this.initEvents()
	}

	initEvents(){
		this.selectHeader.addEventListener('click', () => {
			this.toggleSelect()
		})

		this.options.forEach( option => {
			let optionTxt = option.querySelector('.option__txt')
			optionTxt.addEventListener('click', () => {
				if(option.classList.contains('selected') || this.isAnimating) return
				this.isAnimating = true
				this.resetSelect()

				let dataOption = option.dataset.option;
				this.select.dataset.opzioneSelezionata = dataOption;
				// imposto il valore della vera select
				this.fakeSelect.value = dataOption;

				gsap.to(this.selectHeaderTxt,0.4,{
					autoAlpha:0,
					onComplete: () => {
						this.select.classList.add('scelta-effettuata'); /*serve per il css*/
						option.classList.add('selected');
						this.selectHeaderTxt.innerHTML = optionTxt.innerHTML;
					}
				});
				gsap.to(this.selectHeaderTxt,0.4,{
					autoAlpha:1,
					delay:0.4,
					onComplete: () => {
						this.isAnimating = false;
						this.checkStatus();
					}
				});
				this.closeSelect();
			})
			optionTxt.addEventListener('mouseenter', () => {
				if(option.classList.contains('selected')) return;
				gsap.to(option,0.4,{
					backgroundColor:colors.tiffany
				});
				// gsap.to(optionTxt,0.4,{
				// 	color:colorRed
				// });
			})

			optionTxt.addEventListener('mouseleave', () => {
				if(option.classList.contains('selected')) return;
				gsap.to(option,0.4,{
					backgroundColor:'transparent'
				});
				// gsap.to(optionTxt,0.4,{
				// 	color:colorBrown
				// });
			})
		})

		//chiudo la select quando clicco in giro per il document
		document.addEventListener('click', e => {
			if(!e.target.classList.contains('target-dont-close') && this.select.classList.contains('open')){
				this.closeSelect();
			}
		});

	}

	checkStatus(){
		if(this.select.classList.contains('campo-obbligatorio')){
			let opzioneSelezionata = this.select.dataset.opzioneSelezionata
			let errorValue = ''
			if(opzioneSelezionata == ''){
				this.showError()
				errorValue = 'si'
			}
			else{
				this.hideError()
				errorValue = 'no'
			}
			return errorValue
		}
	}

	showError(){
		gsap.to(this.labelError,{
            duration:0.4,
			autoAlpha:1
		})
		this.errorCheckContainer.classList.add('errore-attivo')
	}

	hideError(){
		gsap.to(this.labelError,{
            duration:0.4,
			autoAlpha:0
		})
		this.errorCheckContainer.classList.remove('errore-attivo')
	}

	resetSelect(){
		this.options.forEach( option => {
			option.classList.remove('selected')
		})
	}

	toggleSelect(){
		if(this.select.classList.contains('open')){
			this.closeSelect()
		}
		else{
			this.openSelect()
		}
	}
	closeSelect(){
		gsap.to(this.selectBody,0.6,{
			height:0
		})
		this.select.classList.remove('open')
	}

	openSelect(){
		gsap.to(this.selectBody,0.6,{
			height:this.selectBodyListHeight
		})
		this.select.classList.add('open')
	}
}

export {Form}